import { MainLayout } from "@/components/layout/MainLayout/MainLayout"
import { UPGRADE_PATH } from "@/utils/upgradeEntry"
import { useCallback } from "react"
import { useNavigate, useSearchParams } from "react-router"
import { CheckoutResult } from "./CheckoutResult"
import { UpgradeBreadcrumb } from "./UpgradeBreadcrumb"

/** /upgrade/return?session_id=...: complete shows the success flow, open goes
 *  back to the plan picker. */
export const UpgradeReturnPage: React.FC = () => {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const sessionId = params.get("session_id")
  const backToPlans = useCallback(() => void navigate(UPGRADE_PATH), [navigate])
  return (
    <MainLayout
      headerLeftElement={<UpgradeBreadcrumb onBackToPlans={backToPlans} />}
      contentCenter={
        <div data-testid="upgrade-return-page" className="h-full">
          <CheckoutResult sessionId={sessionId} onBackToPlans={backToPlans} />
        </div>
      }
    />
  )
}
